import { render, staticRenderFns } from "./CHarmfulFactor.vue?vue&type=template&id=05bad6c5"
import script from "./CHarmfulFactor.vue?vue&type=script&lang=js"
export * from "./CHarmfulFactor.vue?vue&type=script&lang=js"
import style0 from "./CHarmfulFactor.vue?vue&type=style&index=0&id=05bad6c5&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05bad6c5')) {
      api.createRecord('05bad6c5', component.options)
    } else {
      api.reload('05bad6c5', component.options)
    }
    module.hot.accept("./CHarmfulFactor.vue?vue&type=template&id=05bad6c5", function () {
      api.rerender('05bad6c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CHarmfulFactor.vue"
export default component.exports